export const HARDCODE = {
  KEY23: "in2w_key23",
  KEY16: "in2w_key16",
  KEY20: "in2w_key20",
  UPA_PRICE: "in2w_upa_price",
};
